export default [
	{
		modulo: 21,
		privilegio: 173,
		routerName: 'programacao-de-voo',
		routerPath: '/programacao-de-voo',
		componentName: 'ProgramacaoDeVoo',
		componentPath: 'modules/layout/programacao-de-voo/main'
	},
]
